import React from "react";

export default function CardTotais({
    clientes,
    qtdecobrarpendente,
    valorcobrarpendente,
    qtdecobrarefetivado,
    valorcobrarefetivado,
    vendas,
    formatarMoeda
}) {

    return (
        <div className="row g-3 mb-4">

            <div className="col-md-4 col-sm-12">
                <div className="card shadow-sm text-center p-3">
                    <i className="fa fa-users fa-2x text-primary mb-2"></i>

                    <h6>Total de Clientes</h6>

                    <h3>{clientes}</h3>
                </div>
            </div>

            <div className="col-md-4 col-sm-12">
                <div className="card shadow-sm text-center p-3">

                    <i className="fa fa-file-invoice-dollar fa-2x text-warning mb-2"></i>

                    <h6>Cobranças</h6>

                    <h3>
                        {qtdecobrarpendente} - {formatarMoeda(valorcobrarpendente)}
                        {" | "}
                        {qtdecobrarefetivado} - {formatarMoeda(valorcobrarefetivado)}
                    </h3>

                </div>
            </div>

            <div className="col-md-4 col-sm-12">
                <div className="card shadow-sm text-center p-3">

                    <i className="fa fa-check-circle fa-2x text-success mb-2"></i>

                    <h6>Vendas Realizadas</h6>

                    <h3>{vendas}</h3>

                </div>
            </div>

        </div>
    );

}